<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Projects"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="projects"
    :headerTitle="'Projects'|pgettext('ProjectsView')"
    :items="ds"
    checkbox-row-selection
    export-to-csv
    :exportToCsvFilename="'projects'|pgettext('ExportFilename')"
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <ItpButton
        :icon="$config.project.addProjectIcon"
        :text="'New project...'|pgettext('ProjectsView')"
        size="sm"
        variant="light"
        class="mx-2"
        @click="evh_6466705138206980_click($event, {})"
      >
      </ItpButton>
      <PageHelp
        path="/projects/projects.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "projects",
    path: "/projects",
    component: "Projects"
  }
)

@Component()
export default class Projects extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedItems!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_project')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedItems: [
        ]
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "code",
          name: this.$fn.pgettext("ProjectsView", "Code"),
          type: "command",
          formatter: {
            name: "routeLink",
            to: "project",
            params: {
              id: "id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "name",
          name: this.$fn.pgettext("ProjectsView", "Name"),
          type: "command",
          formatter: {
            name: "routeLink",
            to: "project",
            params: {
              id: "id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("ProjectsView", "Projects"),
        icon: this.$config.project.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4174_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4174, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_4176_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_4176, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_showModal_4178_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6466705138206980_showModal_4178, alias=undefined
    return {
      name: "CreateProject",
    }
  }

  async evh_6466705138206980_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4174: actions.CloseModalAction;
    evh_7315092382398562_close_4173: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_4176: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_4175: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_6466705138206980_showModal_4178: actions.ShowModalAction;
    evh_6466705138206980_click_4177: actions.EventHandlerImpl;
    evh_6466705138206980_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4174 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4174_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4173 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4174,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4173],
      }
    );
    const act_2248226175642056_setData_4176 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_4176_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_4175 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_4176,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_4175],
      }
    );
    const act_6466705138206980_showModal_4178 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6466705138206980_showModal_4178_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_click_4177 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_showModal_4178,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_6466705138206980_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_click_4177],
      }
    );
    return {
      act_7315092382398562_closeModal_4174,
      evh_7315092382398562_close_4173,
      evh_7315092382398562_close,
      act_2248226175642056_setData_4176,
      evh_2248226175642056_selectedRowsChanged_4175,
      evh_2248226175642056_selectedRowsChanged,
      act_6466705138206980_showModal_4178,
      evh_6466705138206980_click_4177,
      evh_6466705138206980_click,
    }
  }
}

Vue.component("Projects", Projects);

</script>